const GreenSectionHeader = ({ additionalTopPadding, heading }: { heading: string, additionalTopPadding?: boolean }): JSX.Element => {
    return <h2 className={`text-center text-brand-green text-3xl font-bold p-5 ${additionalTopPadding && "pt-10 pb-5"}`}>{heading}</h2>
}

export default GreenSectionHeader;